import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";

const ReportDefinitionDeletionDialog = ({
  dialogIsOpen,
  onClose,
  reportDefinitionToDelete,
  onConfirmDeletion,
}: {
  dialogIsOpen: boolean;
  onClose: () => void;
  reportDefinitionToDelete: ReportExecutionOrder;
  onConfirmDeletion: (
    procedureDefinitionToDelete: ReportExecutionOrder
  ) => void;
}) => {
  return (
    <Dialog open={dialogIsOpen} onClose={onClose}>
      <DialogTitle>Confirm deletion</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete{" "}
          {reportDefinitionToDelete?.report_definition_id}?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={() => {
            onConfirmDeletion(reportDefinitionToDelete);
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportDefinitionDeletionDialog;
